import { z } from 'zod/v4';

export const CreateUserCompanyBodySchema = z.object({
  companyId: z.string().min(1, 'Company ID is required'),
  userId: z.string().min(1, 'User ID is required'),
  /**
   * An `iam_roles.key` for `companyId`'s tenant (including a custom role).
   * Validated against the tenant's roles in `CreateUserCompanyService.create`.
   */
  role: z.string().min(1, 'Role is required'),
});

export type CreateUserCompanyBody = z.infer<typeof CreateUserCompanyBodySchema>;

export const CreateUserCompanyResponseSchema = z.object({
  id: z.string(),
  userId: z.string(),
  companyId: z.string(),
  isPrimary: z.boolean(),
  hasAgreedWithTerms: z.boolean(),
});

export type CreateUserCompanyResponse = z.infer<
  typeof CreateUserCompanyResponseSchema
>;
